import React from "react";

export default function CheckIcon({ size = 16, color = "currentColor" }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" width={size} height={size}>
      <path d="M5 12l5 5 9-11" />
    </svg>
  );
}
